<template>
  <div class="modal fade" :id="'kt_modal_' + id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="updatePopulation" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('qvct_survey.population.updated')}}</h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-name`"
                  type="text"
                  :label="$t('qvct_survey.population.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('qvct_survey.population.name_placeholder')"
                  v-model="formData.name"
              />

              <Input
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-acronym`"
                  type="text"
                  :label="$t('qvct_survey.population.acronym')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('qvct_survey.population.acronym_placeholder')"
                  v-model="formData.acronym"
              />



              <div class="col-12">
                <label class="form-label fs-6 text-black">
                  {{$t('steps.color')}} <span class="text-danger">*</span>
                </label>
                <div >
                  <ColorPicker
                      v-model:pureColor="formData.color"
                      format="hex"
                  />
                </div>
              </div>
            </div>


          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
            <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="processing"/>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {ref, defineEmits, defineProps, onMounted} from "vue";
import Input from "@/components/Input.vue";
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
const store = useStore()
const {locale} = useLocales()
const emit = defineEmits(['reload'])
const props = defineProps({
  id: { type: String, required: true },
  isEdit: { type: Boolean, default: false },
  editForm: {
    default: () => ({
      id: null,
      name: '',
      acronym: '',
      color: "#000",
    })
  }
})


const processing = ref(false)
const formData = ref(props.editForm)

function closeModal(){
  $("#kt_modal_" + props.id).modal('hide')
}



function updatePopulation() {
  processing.value = true

  store.dispatch('qvctPopulation/updateQvctPopulation', formData.value)
      .then(res => {
        loadData()
        $('#'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t("notification.population_updated"))
        emit('reload')
        closeModal()
      })
      .finally(() => processing.value = false)
}

function loadData() {
  Promise.all([
    store.dispatch('qvctPopulation/loadQvctPopulation'),
  ])
}

onMounted(() => {
  loadData()
})


</script>

<style scoped></style>
